import { AiFillCopyrightCircle } from "react-icons/ai";


function Footer() {
  return (
  	<div>
  	  <AiFillCopyrightCircle />
  	  2025 Sonal Prasad. All rights reserved.
  	</div>
  );
}

export default Footer;